import { Route, Router, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Components/Home";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Error from "./Components/Error";
import Navbar from "./Components/Navbar";
import Projects from "./Components/Projects";

function App() {
  return (
    <div className=" ">
      <div className="   mx-auto">
        {/* <Navbar /> */}

        <Routes>
          <Route
            exact
            path="/"
            element={<Home key="/" />}
            errorElement={<Error />}
          />
          <Route
            exact
            path="/about"
            element={<About key="/" />}
            errorElement={<Error />}
          />
          <Route
            exact
            path="/resume"
            element={<Resume key="/" />}
            errorElement={<Error />}
          />
          <Route
            exact
            path="/contact"
            element={<Contact key="/" />}
            errorElement={<Error />}
          />
          <Route
            exact
            path="/projects"
            element={<Projects key="/" />}
            errorElement={<Error />}
          />
          <Route exact path="/*" element={<Error />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
